import { render, staticRenderFns } from "./BayWindowConfig.vue?vue&type=template&id=8478fb94"
import script from "./BayWindowConfig.vue?vue&type=script&lang=js"
export * from "./BayWindowConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports